import styled from 'styled-components';

//helpers
import { screen } from '@/helpers/screen';

//miranda tokens
import { getToken } from '@loadsmart/miranda-tokens';

//theme
import { homeColor } from '@/theme/ai';

//components
import { Section, SectionTitle, SectionLede, Kicker } from '../SectionHeading';

export const ProofSection = styled(Section)`
  background: ${homeColor.bg2};
  position: relative;
  text-align: center;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background-image: radial-gradient(
      circle,
      rgba(255, 255, 255, 0.045) 1px,
      transparent 1.6px
    );
    background-size: 26px 26px;
    opacity: 0.3;
    pointer-events: none;
  }
`;

export const SectionTitleCustom = styled(SectionTitle)`
  margin: 0 auto 16px;
  max-width: initial;
`;

export const KickerCustom = styled(Kicker)`
  margin: auto;
  width: fit-content;
`;

export const BigNums = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: 1fr;
  gap: 26px;
  margin-top: 44px;

  ${screen.lg} {
    grid-template-columns: repeat(3, 1fr);
  }
`;

export const BigNum = styled.div``;

export const BigNumValue = styled.div`
  font-family: ${getToken('font-family-default')};
  font-size: 40px;
  font-weight: 800;
  letter-spacing: -0.03em;
  font-variant-numeric: tabular-nums;
  color: ${homeColor.green};
  margin: 0 auto;

  ${screen.md} {
    font-size: 48px;
  }

  ${screen.lg} {
    font-size: 60px;
  }

  ${screen.xxlg} {
    font-size: 64px;
  }
`;

export const BigNumLabel = styled.div`
  font-family: ${getToken('font-family-default')};
  color: ${homeColor.white};
  font-size: 15px;
  margin: 6px auto 0;
  max-width: 215px;
`;
